import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { StudentCompanyCourseFacade } from '@domains/course/domain/application-services/student-company-course.facade';
import { CollapsePanelKeyboardDirective } from '@domains/shared/feature/directives/collapse-panel-keyboard.directive';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { noop, Subscription } from 'rxjs';

@Component({
  selector: 'app-bp-collapse',
  templateUrl: './bp-collapse.component.html',
  styleUrls: ['./bp-collapse.component.scss'],
  standalone: true,
  imports: [CommonModule, NzCollapseModule, CollapsePanelKeyboardDirective]
})
export class BpCollapseComponent implements OnDestroy {

  @Input() header: string = '';

  @Input() content: string = '';

  @Input() expanded: boolean = false;

  @Input() sectionId: string = '';

  subs: Subscription = new Subscription();

  constructor(private courseFacade: StudentCompanyCourseFacade) { }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  /**
   * Panel hlásí rozbalení i sbalení, do statistiky patří jen rozbalení. Dřív na
   * panelu visel `(click)`, který bublal z celého obsahu sekce — záznam tak vznikl
   * při kliku kamkoli dovnitř i při zavření a neříkal, že si někdo sekci otevřel.
   */
  onActiveChange(active: boolean): void {
    this.expanded = active;

    if (!active || !this.sectionId) {
      return;
    }

    this.subs.add(this.courseFacade.registerSectionExpanded(this.sectionId).subscribe({
      next: noop
    }));
  }
}
